import { render } from "./ChipGroup.vue?vue&type=template&id=8454c548&scoped=true"
import script from "./ChipGroup.vue?vue&type=script&lang=js"
export * from "./ChipGroup.vue?vue&type=script&lang=js"

import "./ChipGroup.vue?vue&type=style&index=0&id=8454c548&lang=scss"
import "./ChipGroup.vue?vue&type=style&index=1&id=8454c548&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8454c548"]])

export default __exports__